/**
 * Blocks staff-uploaded attachment downloads until the client has
 * opened the Assumptions tab. Carries the same disclaimer wording as
 * the Costs tab-open notice so the client knows the file must be
 * read against the quoted scope.
 */
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alert-dialog";

export default function AttachmentGateDialog({ attachment, onClose, onReviewAssumptions }) {
  return (
    <AlertDialog
      open={attachment != null}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <AlertDialogContent data-testid="attachment-gate-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Before you download this file</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3">
              <p>
                {attachment?.filename ? (
                  <>
                    <span className="font-mono text-stone-700">{attachment.filename}</span>{" "}
                    should be read together with our comments and assumptions.
                  </>
                ) : (
                  "This file should be read together with our comments and assumptions."
                )}{" "}
                Please review the Assumptions tab first &mdash; the download will
                then be available.
              </p>
              <p>
                The contents are based on the specifications you shared with
                us, together with our comments, assumptions, and proposed
                timings. The Assumptions tab sets out the full scope on which
                they are based.
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="attachment-gate-cancel">
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onReviewAssumptions}
            data-testid="attachment-gate-review-btn"
            className="bg-[#1B4F8A] hover:bg-[#173f6e]"
          >
            Review assumptions
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
